


import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FaBolt, FaStar, FaEye } from 'react-icons/fa'
import { AiFillHeart, AiOutlineShoppingCart } from 'react-icons/ai'
import { useDispatch, useSelector } from 'react-redux'
import toast from 'react-hot-toast'
import { add_to_card, add_to_wishlist, messageClear } from '../store/reducers/cardReducer'

const stripHtml = (value = '') => String(value).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()

const DigitalProductCard = ({ product }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { userInfo } = useSelector(state => state.auth)
  const { successMessage, errorMessage } = useSelector(state => state.card)

  // ✅ Qiymət hesablanması
  // product.price artıq model-də düzgün set olunub:
  // - Paketli məhsulda: default paketin qiyməti
  // - Paketsiz məhsulda: əsas qiymət
  const finalPrice = product?.discountPrice > 0 ? product.discountPrice : product.price

  const discountPercent =
    product?.discountPrice > 0
      ? Math.round(((product.price - product.discountPrice) / product.price) * 100)
      : 0

  const add_card = () => {
    if (!userInfo) return navigate('/login')

    // ✅ Paketli məhsulsa → detail səhifəyə yönləndir (paket seçmək üçün)
    if (product.hasPackages) {
      navigate(`/digital/product/${product.slug}`)
      return
    }

    // ✅ Paketsiz məhsulsa → birbaşa səbətə əlavə et
    dispatch(
      add_to_card({
        userId: userInfo.id,
        quantity: 1,
        productId: product._id,
        packageId: null,  // paketsiz
        price: finalPrice
      })
    )
  }

  const add_wishlist = () => {
    if (!userInfo) return navigate('/login')

    dispatch(
      add_to_wishlist({
        userId: userInfo.id,
        productId: product._id,
        name: product.name,
        price: finalPrice,
        image: product.thumbnail,
        discount: discountPercent,
        rating: product.rating,
        slug: product.slug
      })
    )
  }

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage || 'Məhsul səbətə əlavə olundu')
      dispatch(messageClear())
    }

    if (errorMessage) {
      toast.error(errorMessage || 'Nəsə düzgün getmədi.')
      dispatch(messageClear())
    }
  }, [successMessage, errorMessage, dispatch])

  return (
    <div className='block w-full group rounded-lg overflow-hidden border border-slate-200 bg-white hover:shadow-md transition-all duration-300'>
      <div className='relative overflow-hidden'>
        {discountPercent > 0 && (
          <div className='absolute left-1.5 top-1.5 z-10 px-2 py-0.5 text-[10px] font-bold rounded-full bg-red-500 text-white'>
            -{discountPercent}%
          </div>
        )}

        <div className='absolute right-1.5 top-1.5 z-10 flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-500 text-white text-[10px] font-bold'>
          <FaBolt className='text-yellow-200' />
          Instant
        </div>

        <Link to={`/digital/product/${product.slug}`}>
          <img className='w-full h-[130px] object-cover' src={product.thumbnail} alt={`${stripHtml(product.name || 'Digital məhsul')} - ItemZo`} />
        </Link>

        <div className='absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-all duration-300'></div>

        {/* Actions */}
        <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-2 z-10'>
          <li
            onClick={add_wishlist}
            className='w-[32px] h-[32px] cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-[#7c3aed] hover:text-white hover:rotate-[720deg] transition-all'
          >
            <AiFillHeart size={15} />
          </li>

          <Link
            to={`/digital/product/${product.slug}`}
            className='w-[32px] h-[32px] cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-[#7c3aed] hover:text-white hover:rotate-[720deg] transition-all'
          >
            <FaEye size={14} />
          </Link>

          <li
            onClick={add_card}
            className='w-[32px] h-[32px] cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-[#7c3aed] hover:text-white hover:rotate-[720deg] transition-all'
          >
            <AiOutlineShoppingCart size={16} />
          </li>
        </ul>
      </div>

      <div className='p-2'>
        <h2 className='text-[12px] font-semibold text-slate-800 line-clamp-2 min-h-[32px]'>
          {product.name}
        </h2>
        {/* ✅ Rəsmi məhsul nişanı */}
        <span className='mt-1 inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[9px] font-bold text-emerald-700 border border-emerald-200'>
          ✔ Itemzo rəsmi məhsulu
        </span>

        <div className='flex items-center justify-between mt-1.5'>
          {/* ✅ QİYMƏT - product.price artıq düzgündür */}
          <span className='text-[13px] font-bold text-slate-900'>
            ₼{finalPrice}
          </span>

          <div className='flex flex-row items-center gap-0.5 text-yellow-400 whitespace-nowrap'>
            {[...Array(5)].map((_, i) => (
              <FaStar
                key={i}
                className={`inline-block text-[10px] ${
                  i < Math.floor(product.rating ?? 5) ? '' : 'opacity-30'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DigitalProductCard



